import { render, staticRenderFns } from "./ReminderAutoSend.vue?vue&type=template&id=4bec1f3c"
import script from "./ReminderAutoSend.vue?vue&type=script&lang=ts"
export * from "./ReminderAutoSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bec1f3c')) {
      api.createRecord('4bec1f3c', component.options)
    } else {
      api.reload('4bec1f3c', component.options)
    }
    module.hot.accept("./ReminderAutoSend.vue?vue&type=template&id=4bec1f3c", function () {
      api.rerender('4bec1f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderAutoSend.vue"
export default component.exports